import { CSSProperties, useEffect, useState } from 'react';
import SvgIcon from 'components/commons/icons/SvgIcon';
import { ReactComponent as Ic_Eye_Closed } from 'resources/icons/Ic_Eye_Closed.svg';
import { ReactComponent as Ic_Eye} from 'resources/icons/Ic_Eye.svg';

import './passwordInput.scss';

export interface IPasswordInput {
    value?: string | null;
    placeholder: string;
    actionOnChange: (...params: any)=>void;
    style?:CSSProperties;
    id?:string
    disabled?:boolean
    className?:string;
    onClear?:(...params)=>void
    onFocus?:(...params)=>void
    onBlur?:(...params)=>void
  }

export default function PasswordInput(props:IPasswordInput) {
    const {placeholder, actionOnChange, style, value, onFocus, onBlur} = props;
    const [foco, setFoco] = useState(false);
    const [inputValue, setValue] = useState('');
    const [ofuscated, setOfuscated] = useState(true);

    const onChange = (e) => {
    setValue(e.target.value);
    actionOnChange(e.target.value);
    };

    useEffect(()=>{
        if(value?.length){
        setValue(String(value));
        }
    },[value]);
    return (

        <div className={'searchInput' + (foco ? ' focused' : '') + (props.disabled ? ' --disabled' : '') + (props.className ? ' ' + props.className : '')} style={{...style}}>
            <input type={ofuscated ? 'password' : 'text'} placeholder={placeholder} className='searchInput_input' onFocus={()=>{setFoco(true); onFocus && onFocus();}} onBlur={()=>{setFoco(false); onBlur && onBlur();}} value={inputValue} onChange={(e)=>onChange(e)} disabled={props.disabled}/>
            <span className='searchInput_iconSearchContainer--left' onClick={()=>setOfuscated(!ofuscated)}>
                <SvgIcon
                    ariaLabel={ofuscated ? 'icono-mostrar-pass' : 'icono-ocultar-pass'}
                    Icon={ofuscated ? Ic_Eye_Closed : Ic_Eye}
                    className='searchInput_iconSearch'
                />
            </span>
        </div>
    );
}
